import { RefObject, useImperativeHandle, useState } from "react";

import { Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import { FaXmark } from "react-icons/fa6";
import { Link, useParams } from "react-router-dom";

import noAvatarImage from "../../../../imagenes/no_avatar.svg";
import { TProgressSummary } from "../../hooks/useMyCourseInstructor";
import { TRequestMoneyDialogRef } from "./RequestMoneyDialog";

import "./finished_summary_dialog.scss";

export type TFinishedSummaryDialogProps = {
	ref: RefObject<TFinishedSummaryDialogRef | null>;
	requestMoneyDialogRef: RefObject<TRequestMoneyDialogRef | null>;
};
export type TFinishedSummaryDialogRef = {
	open: (finishedSummary: TProgressSummary) => void;
	close: () => void;
};

export function FinishedSummaryDialog(props: TFinishedSummaryDialogProps) {
	const [isOpen, setIsOpen] = useState(false);
	const [finishedSummary, setFinishedSummary] =
		useState<TProgressSummary | null>(null);
	const { slug } = useParams();

	const open = (summary: TProgressSummary) => {
		setIsOpen(true);
		setFinishedSummary(summary);
	};

	const close = () => {
		setIsOpen(false);
		setFinishedSummary(null);
	};

	useImperativeHandle(
		props.ref,
		() => ({
			open,
			close,
		}),
		[],
	);

	const student = finishedSummary?.student;
	const studentName =
		`${student?.firstName ?? ""} ${student?.lastName ?? ""}`.trim();

	const airHoursText = `${finishedSummary?.airHours.toFixed(1)} hrs in Flight`;
	const simulatorHoursText = `${finishedSummary?.simulatorHours.toFixed(1)} hrs in Sim`;
	const milesFlownText = `${finishedSummary?.milesFlown} miles Flown`;

	const onClickOpenRequestMoney = () => {
		if (!finishedSummary) {
			return;
		}

		props.requestMoneyDialogRef.current?.open(
			studentName,
			finishedSummary.studentId,
			finishedSummary.id,
		);
	};

	return (
		<Dialog
			open={isOpen && !!finishedSummary}
			onClose={close}
			className="finished-summary-dialog">
			<DialogContent>
				<div className="dialog-header">
					<IconButton onClick={close}>
						<FaXmark className="normal-icon close-icon" />
					</IconButton>
				</div>
				<div className="dialog-content-container">
					<img
						src={
							student?.profile?.thumbnail ||
							student?.profile?.url ||
							noAvatarImage
						}
						className="avatar"
					/>
					<div>
						<Link
							to={`/profile/${student?.profile?.profileSlug}`}
							target="_blank"
							className="underline-on-hover-link black-text">
							<Typography className="big-text bold">{studentName}</Typography>
						</Link>
						<div className="summary-detail-container item-separator-small">
							<Typography className="normal-text">{airHoursText}</Typography>
							<Typography className="normal-text">
								{simulatorHoursText}
							</Typography>
							<Typography className="normal-text">{milesFlownText}</Typography>
						</div>
						<Typography
							onClick={onClickOpenRequestMoney}
							className="normal-text bold gray-text underline-link">
							Request money
						</Typography>
						<Link
							to={`/teaching/${slug}/${finishedSummary?.studentId}`}
							className="underline-link blue-text">
							<Typography className="normal-text bold item-separator-small">
								Student Binder
							</Typography>
						</Link>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	);
}
